// extracted by mini-css-extract-plugin
module.exports = {"text":"_14JEb8M6MGYOa4D3Lq3_NR"};